import { render } from "./AdBox.vue?vue&type=template&id=840c7d4e&scoped=true"
import script from "./AdBox.vue?vue&type=script&lang=js"
export * from "./AdBox.vue?vue&type=script&lang=js"

import "./AdBox.vue?vue&type=style&index=0&id=840c7d4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840c7d4e"]])

export default __exports__